var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "subscriber-count",
      class: _vm.$vuetify.theme.dark === true ? ` dark` : ` light`,
    },
    [_vm._v(" " + _vm._s(_vm.count) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }